import React from 'react';
import { cn } from '../../utils/cn';

export interface ButtonGroupProps {
  children: React.ReactNode;
  vertical?: boolean;
  className?: string;
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  children,
  vertical = false,
  className,
}) => {
  return (
    <div className={cn('btn-group', vertical && 'btn-group-vertical', className)}>{children}</div>
  );
};
